import js from '../images/js.svg';
import react from '../images/react.svg';


let skill_language_store = [
	{
		name: 'React JS/React Hooks',
		level: 'experience',
		logo: react
	},
	{
		name: 'JavaScript',
		level: 'very good',
		logo: js
	},
	{
		name: 'Redux',
		level: 'experience',
		logo: react
	},
	{
		name: 'Redux-saga Middleware',
		level: 'experience',
		logo: react
	},
	{
		name: 'Next Js ',
		level: 'very good',
		logo: react
	},
	{
		name: 'AEM UI',
		level: 'very good',
		logo: ''
	},
	{
		name: 'Node js',
		level: 'beginner',
		logo: ''
	},
	{
		name: 'HTML/CSS/Bootstrap/Material UI',
		level: 'experience',
		logo: ''
	},
	{
		name: 'JQuery',
		level: 'average',
		logo: ''
	},
	{
		name: 'SASS/LESS',
		level: 'average',
		logo: ''
	},
	{
		name: 'MongoDB',
		level: 'average',
		logo: ''
	},
	{
		name: 'Webpack configuration',
		level: 'average',
		logo: ''
	},
	{
		name: 'Testing with JEST and Enzyme',
		level: 'average',
		logo: ''
	}
];
let skill_tool_store = [
	{
		name: 'Git - BitBucket/Github',
		level: 'very good',
		logo: ''
	},
	{
		name: 'VS Code',
		level: 'experience',
		logo: ''
	},
	{
		name: 'Illustrator',
		level: 'beginner',
		logo: ''
	}
];

export { skill_language_store, skill_tool_store }